module.exports = __webpack_public_path__ + "d1e308048e6b560436d1f25d56abb202.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/makeup-diva.png
// module id = 2460
// module chunks = 0